import Network from '@/services/network'
import { ref } from 'vue'

export default function handlePayBill() {
	const network = new Network;
	const loading = ref(false)
	
	const fetchPayBillList = (query) => {
		return network.api('get', '/pay-bill' + query);
	}

	const returnBillPayment = (paymentId, data) => {
		return network.api('post', `/pay-bill/${paymentId}/return`, data);
	}

	return {
		fetchPayBillList,
		returnBillPayment,
		loading
	}
}